<script setup lang="ts">
import { cn } from '@/utils';
import { parseVideoUrl } from '~~/utils';

interface Props {
	title?: string;
	src: string;
	class?: string;
}

const props = defineProps<Props>();
const emit = defineEmits<{
	(e: 'play', videoUrl: string): void;
}>();

const formattedSrc = computed(() => parseVideoUrl(props.src));
const playerElementId = useId();
const player = ref<any>(null);

const videoId = computed(() => {
	const url = new URL(props.src);
	return url.searchParams.get('v') || props.src.split('/').pop();
});

const YTBStatus: Record<number, string> = {
	1: 'playing'
};

onMounted(() => {
	const tag = document.createElement('script');
	tag.src = 'https://www.youtube.com/iframe_api';
	const firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag?.parentNode?.insertBefore(tag, firstScriptTag);

	(window as any).onYouTubeIframeAPIReady = () => {
		player.value = new (window as any).YT.Player(playerElementId, {
			videoId: videoId.value,
			events: {
				onStateChange: (event: any) => {
					const status = YTBStatus[event.data];

					if (status === 'playing') {
						emit('play', formattedSrc.value);
					}
				}
			}
		});
	};
});
</script>

<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
	<LazyClientOnly>
		<div
			:id="playerElementId"
			:class="cn('size-full', props.class)"
			class="skeleton"
		>
			<iframe
				:src="formattedSrc"
				:class="cn('size-full', props.class)"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			/>
		</div>
	</LazyClientOnly>
</template>

<style scoped>
.skeleton {
	background-color: #e0e0e0;
	animation: skeleton-pulse 1.5s infinite ease-in-out;
}

@keyframes skeleton-pulse {
	0%,
	100% {
		background-color: #e0e0e0;
	}
	50% {
		background-color: #f0f0f0;
	}
}
</style>
